import moment from "moment"
import { LinkField } from "../../linkField"
import { Img } from "../../../layout/Img"

export const FeaturedEvents = ({ events }) => {
  const {
    eventDate,
    title,
    eventType,
    eventSignUpLink,
    eventImage,
    eventDescription,
  } = events[0]

  return (
    <section className="container flex flex-col mx-auto lg:w-11/12 body-font">
      <div className="flex flex-col items-center justify-start mx-4 lg:flex-row">
        <div className="flex-initial lg:flex-auto lg:w-6/12">
          <div className="relative flex items-center justify-center">
            <Img image={eventImage[0]} className="flex-auto w-full m-4" />
          </div>
        </div>

        <div className="flex-auto lg:w-6/12">
          <div className="flex flex-col items-start gap-4 p-6 lg:px-12">
            <span className="px-4 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor">
              {eventType[0]} {eventType[1] && <>+ {eventType[1]}</>}
            </span>
            <h3 className="max-w-md text-2xl font-semibold">{title}</h3>
            <h4 className="mt-2 text-xl">
              {moment(eventDate.start).format("D MMMM YYYY")}
            </h4>
            <p className="text-md">
              {moment(eventDate.start).format("h:mm a")}-
              {moment(eventDate.end).format("h:mm a")}
            </p>
            <div
              className="pt-2 mx-auto font-normal text-secondary"
              dangerouslySetInnerHTML={{ __html: eventDescription }}
            />

            <div className="">
              <LinkField
                {...eventSignUpLink}
                className="inline-block px-10 py-3 font-normal text-center text-white rounded bg-pink hover:bg-btnhover"
              >
                Register
              </LinkField>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
